import React, { useEffect, useState } from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";

const CookiePolicy = () => {
  const [loading, setloading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "nedui962",
  };
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/nedui962'
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/nedui962";
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === "complete") {
        l();
      } else if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero">
            <Container>
              <Row className="justify-content-center">
                <Col xl="17">
                  <h1 className="text-center mb-0">Cookies Policy </h1>
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <Row className="justify-content-center mb-11 mb-md-12 mb-xxl-13 mb-xxxl-14">
              <Col xl="18" xxl="16" xxxl="13">
                <p>Effective Date: 12th May 2025</p>
                <p>Company Name: Elderly Life Ltd</p>
                <p>
                  Website{" "}
                  <a href="https://www.elderlylife.com/">www.elderlylife.com</a>
                </p>
                <h2 class="h5">What Are Cookies?</h2>
                <p>
                  Cookies are small text files that websites place on your
                  device to store data about your visit. They help us understand
                  how you use the site, support essential features, and improve
                  your overall experience.
                </p>
                <h2 class="h5">Types of Cookies We Use</h2>
                <section>
                  <h3 class="h6"> Strictly Necessary Cookies </h3>
                  <p class="mb-7">
                    These cookies are essential for the website to function
                    properly. They include:
                  </p>
                  <ListGroup className="br-none mb-7">
                    <ListGroup.Item>
                      Login and session management{" "}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      Security and fraud prevention
                    </ListGroup.Item>
                    <ListGroup.Item>
                      Payment processing (via{" "}
                      <span className="fw-bold">Stripe</span>){" "}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      Infrastructure and uptime support (via Civo – used to
                      serve and store platform functionality)
                    </ListGroup.Item>
                  </ListGroup>
                </section>
                <section>
                  <h3 class="h6">Functional Cookies </h3>
                  <p class="mb-7">
                    These cookies enhance your experience by remembering
                    preferences and enabling custom features. Example:
                  </p>

                  <ListGroup className="br-none mb-7">
                    <ListGroup.Item>
                      Support chat settings (via Intercom)
                    </ListGroup.Item>
                  </ListGroup>
                </section>
                <section>
                  <h3 class="h6">Performance and Analytics Cookies </h3>
                  <p class="mb-7">
                    These cookies help us understand how users interact with our
                    site so we can improve it. Examples:
                  </p>

                  <ListGroup className="br-none">
                    <ListGroup.Item>
                      Google Analytics for page visits, clicks, etc.
                    </ListGroup.Item>
                    <ListGroup.Item>Intercom usage analytics </ListGroup.Item>
                  </ListGroup>
                  <p className="mb-7">
                    We anonymise IP addresses wherever possible and do not use
                    this data to personally identify you.{" "}
                  </p>
                </section>
                <section>
                  <h3 class="h6">Third-Party Cookies </h3>
                  <p class="mb-7">
                    We may embed third-party services that place their own
                    cookies. These services include:
                  </p>

                  <ListGroup className="br-none">
                    <ListGroup.Item>
                      <span className="fw-bold">Stripe</span> – secure payments
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span className="fw-bold">Intercom</span> – chat and
                      support{" "}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span className="fw-bold">Xero</span> – invoice visibility
                      (limited use)
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <span className="fw-bold">Civo</span> – platform
                      infrastructure (may store technical session cookies)
                    </ListGroup.Item>
                  </ListGroup>
                  <p className="mb-7">
                    Each third-party service is governed by its own cookie and
                    privacy policies.
                  </p>
                </section>
                <h2 class="h5">Managing Your Cookie Preferences</h2>
                <p>
                  When you first visit our site, you’ll be prompted to accept or
                  manage cookies. You can:{" "}
                </p>
                <ListGroup className="br-none">
                  <ListGroup.Item>Accept all cookies</ListGroup.Item>
                  <ListGroup.Item>Reject non-essential cookies</ListGroup.Item>
                  <ListGroup.Item>
                    Change your settings at any time
                  </ListGroup.Item>
                </ListGroup>
                <p>You can also manage cookies via your browser:</p>
                <ListGroup className="br-none">
                  <ListGroup.Item>
                    <a href="https://support.google.com/chrome/answer/95647">
                      Chrome
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer">
                      Firefox
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    {" "}
                    <a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac">
                      Safari
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <a href="https://support.microsoft.com/en-gb/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d">
                      Edge
                    </a>
                  </ListGroup.Item>
                </ListGroup>
                <p class="mb-7">
                  Disabling cookies may impact site functionality.
                </p>
                <h2 class="h5">Data Transfers </h2>
                <p>
                  Some third-party services (e.g. Intercom, Stripe, Civo) may
                  process cookie-related data outside the UK.
                </p>
                <p class="mb-7">
                  We ensure appropriate legal safeguards (like Standard
                  Contractual Clauses) are in place.
                </p>
                <h2 class="h5">Updates to This Policy </h2>
                <p class="mb-7">
                  We may update this Cookies Policy to reflect legal, technical,
                  or operational changes. We recommend checking this page
                  periodically for updates.
                </p>
                <h2 class="h5">Contact Us </h2>
                <p class="mb-7">
                  If you have questions about our use of cookies, please
                  contact: Elderly Life Ltd{" "}
                  <a href="mailto:support@elderlylife.com">
                    support@elderlylife.com
                  </a>
                  <span className="d-flex">
                    Unit H, Gateway 1000 Whittle Way, Stevenage, England, SG1
                    2FP
                  </span>
                </p>
              </Col>
            </Row>
          </Container>
          <Footer />
        </>
      )}
    </>
  );
};

export default CookiePolicy;
